<template>
  <form class="NewsletterForm"
    action="https://www.createsend.com/t/subscribeerror?description="
    data-id="191722FC90141D02184CB1B62AB3DC265C65A3A8F9EC8CC6896119ACFD9BE26FE8001C7E0415F16E05714D135401DD200AFF893F50F2B55E088D85492D91CBED"
    method="post"
    ref="form">

    <p class="t-caps-md c-grey-xlt2"
      v-if="title">
      {{ title }}
    </p>

    <text-input class="NewsletterForm-input"
      id="l260006-260006"
      name="cm-ydllld-ydllld"
      type="email"
      placeholder="Enter your email"
      @submit="submit"
      large />

    <noscript>

      <input type="submit" value="Submit">

    </noscript>

  </form>
</template>

<script>
export default {
  name: 'NewsletterForm',

  props: {
    /**
     * Whether to show the title, and if so, the title text
     */
    title: {
      type: [Boolean, String],
      default () {
        return 'Sign up for our newsletter'
      }
    }
  },

  methods: {
    /**
     * Handle form submit event
     * @param  {Object} $event
     */
    submit ($event) {
      this.$refs.form.submit()
    }
  }
}
</script>

<style>
@import 'properties';

.NewsletterForm {
  margin-top: var(--unit-025);
  width: 100%;
  max-width: 265px;
}
</style>



// WEBPACK FOOTER //
// NewsletterForm.vue?0577755e